/**
 * What a vfs tool answered, as the plain object the chat's own logic reads (`success`, `project_id`, `preview_url`,
 * `service_path`…). The vfs-service MCP server returns it as JSON text inside the MCP envelope
 * (`{ content: [{ type: 'text', text: '{"success":true,...}' }] }`), where the tools it replaced returned the bare
 * object — so reading `response.project_id` directly finds nothing and the chat never learns a project was created or
 * a preview is ready.
 */
export function toolPayload(response) {
    if (!response || typeof response !== 'object') { return response; }
    if (response.structuredContent && typeof response.structuredContent === 'object') { return response.structuredContent; }
    if (!Array.isArray(response.content)) { return response; }
    const texts = response.content
        .map((part) => (part && typeof part.text === 'string' ? part.text : null))
        .filter((text) => text !== null);
    if (texts.length !== 1) { return response; }
    try {
        const parsed = JSON.parse(texts[0]);
        return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : response;
    } catch {
        return response;
    }
}

/** True when the call worked: its own `success` when it has one, else the MCP protocol's error flag. */
export function isToolPayloadSuccess(response) {
    if (!response) { return false; }
    const payload = toolPayload(response);
    if (payload && typeof payload.success === 'boolean') { return payload.success; }
    if (typeof response.success === 'boolean') { return response.success; }
    return Array.isArray(response.content) && response.isError !== true;
}
